import { MouseEvent, useContext, useState } from "react";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Menu, MenuItem } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { TitleBar } from "../../../configs/materialOrder";
import { ROLE } from "../../../data/enums";
import { AuthenticationContext } from "../../../provider/AuthenticationProvider";
import {
    StyledButton,
    TitleText,
    TitleWrapper,
} from "../../../shared/styled/TitleBar";
import AddIcon from "../../../shared/svg/AddIcon";

interface TitleProps {
    onCreateMaterialOrder?: () => void;
}

const materialOrderCreateRoles = [ROLE.MANAGER, ROLE.PURCHASING_STAFF, ROLE.LOGISTIC_MANAGER];
const outsourceOrderCreateRoles = [ROLE.MANAGER, ROLE.PURCHASING_STAFF, ROLE.LOGISTIC_STAFF];

const Title = ({ onCreateMaterialOrder }: TitleProps) => {
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const {
        user: { role },
    } = useContext(AuthenticationContext);
    const canCreateMaterialOrder = materialOrderCreateRoles.includes(role);
    const canCreateOutsourceOrder = outsourceOrderCreateRoles.includes(role);
    const canCreate = canCreateMaterialOrder || canCreateOutsourceOrder;
    const isCreateMenuOpen = Boolean(anchorEl);

    const handleOpenCreateMenu = (event: MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseCreateMenu = () => {
        setAnchorEl(null);
    };

    const handleCreateMaterialOrder = () => {
        handleCloseCreateMenu();
        if (onCreateMaterialOrder) return onCreateMaterialOrder();
        navigate("/material-orders/create");
    };

    const handleCreateOutsourceOrder = () => {
        handleCloseCreateMenu();
        navigate("/outsource-orders/create?returnTab=outsource%20orders");
    };

    return (
        <TitleWrapper>
            <TitleText>{TitleBar.title}</TitleText>
            {canCreate && (
                <>
                    <StyledButton
                        variant="contained"
                        onClick={handleOpenCreateMenu}
                        aria-controls={isCreateMenuOpen ? "create-purchase-order-menu" : undefined}
                        aria-haspopup="true"
                        aria-expanded={isCreateMenuOpen ? "true" : undefined}
                    >
                        <AddIcon />
                        {TitleBar.addButtonText}
                        <ArrowDropDownIcon fontSize="small" />
                    </StyledButton>
                    <Menu
                        id="create-purchase-order-menu"
                        anchorEl={anchorEl}
                        open={isCreateMenuOpen}
                        onClose={handleCloseCreateMenu}
                    >
                        {canCreateMaterialOrder && (
                            <MenuItem onClick={handleCreateMaterialOrder}>
                                Đơn mua hàng vật tư
                            </MenuItem>
                        )}
                        {canCreateOutsourceOrder && (
                            <MenuItem onClick={handleCreateOutsourceOrder}>
                                Đơn mua hàng gia công
                            </MenuItem>
                        )}
                    </Menu>
                </>
            )}
        </TitleWrapper>
    );
};

export default Title;
